var map = {
	"./accept.svg": "c33f",
	"./add-file.svg": "4a7f",
	"./alert-outline.svg": "4eff",
	"./arrow-answer.svg": "ba24",
	"./arrow.svg": "ab4b",
	"./at-sign.svg": "48dd",
	"./calendar-close.svg": "0ac5",
	"./calendar-eye.svg": "1c9a",
	"./calendar.svg": "15fe",
	"./cancel.svg": "1612",
	"./canceled-file.svg": "8a398",
	"./category.svg": "fde2",
	"./change-file.svg": "b7b6",
	"./chat-launch.svg": "2de41",
	"./checkbox-empty.svg": "92b5",
	"./checkbox-indeterminate.svg": "7fb3",
	"./checkbox.svg": "8ceb",
	"./circle-arrow.svg": "8f1b1",
	"./circle-line.svg": "5b7c",
	"./circle-start.svg": "3500",
	"./clock.svg": "26b9",
	"./column.svg": "5ff4",
	"./comment.svg": "ee9e",
	"./comment_q.svg": "fea8",
	"./comment_u.svg": "4ef6",
	"./constructor.svg": "0d34",
	"./continue.svg": "1164",
	"./copy.svg": "45df",
	"./cross.svg": "9524",
	"./crossed.svg": "cf2e",
	"./delete.svg": "7890",
	"./departament.svg": "6fb7",
	"./diagram.svg": "8c4fd",
	"./diskette.svg": "8c7d",
	"./docs.svg": "4808",
	"./dot.svg": "786e",
	"./double-arrow.svg": "5006",
	"./down-scale.svg": "590f",
	"./download.svg": "64b6",
	"./draft.svg": "e37c",
	"./dropdown.svg": "b9e3",
	"./edit.svg": "14ef",
	"./excel.svg": "462e",
	"./exit.svg": "2c02",
	"./eye-slash.svg": "d0d5",
	"./eye.svg": "7982",
	"./file-add.svg": "2bc3",
	"./file-clip.svg": "731b",
	"./file-minus.svg": "49a2d",
	"./filter.svg": "e7fa",
	"./folder-open.svg": "7f0dd",
	"./folder.svg": "1df5",
	"./folders.svg": "bda4",
	"./graph.svg": "c125",
	"./hyphen.svg": "7ef4",
	"./import.svg": "3079",
	"./info.svg": "c26c",
	"./insights.svg": "476e",
	"./invite.svg": "8ffe",
	"./link.svg": "02d4",
	"./loading.svg": "c61c",
	"./lock.svg": "bb06",
	"./long-arrow.svg": "0301",
	"./mail-open.svg": "1871",
	"./mail.svg": "030c",
	"./menu.svg": "395cd",
	"./minus.svg": "a319",
	"./money.svg": "353e",
	"./no-notifications.svg": "ff15",
	"./notifications.svg": "adee",
	"./okay-arrow.svg": "59d5",
	"./person-card.svg": "ba4d",
	"./person-check.svg": "10d5",
	"./person-refresh.svg": "9312",
	"./person-thin.svg": "4892",
	"./person.svg": "1344",
	"./persons.svg": "fcb2",
	"./phone.svg": "3c24",
	"./pie.svg": "1931",
	"./plus-circle.svg": "ff3f",
	"./plus.svg": "19e0",
	"./poll.svg": "43c5a",
	"./price-comment.svg": "a9e9",
	"./printer.svg": "9f94",
	"./question.svg": "1d78",
	"./reminder.svg": "540d",
	"./repeat.svg": "8268",
	"./rotate.svg": "eca6",
	"./search.svg": "c2b8",
	"./send.svg": "26a8",
	"./setting.svg": "c2bb",
	"./share.svg": "125c",
	"./sharp.svg": "8cd1",
	"./signy.svg": "223b",
	"./square-link.svg": "4a6f",
	"./star-outline.svg": "9285",
	"./star.svg": "83bf",
	"./stopped-person.svg": "f7e2",
	"./table.svg": "3eea",
	"./tag-auto.svg": "a62a",
	"./telegram.svg": "3df9",
	"./text.svg": "1d82",
	"./time-ending.svg": "63ea",
	"./up-scale.svg": "b391",
	"./viber.svg": "22c6",
	"./work.svg": "664d",
	"./world.svg": "b10c",
	"./yc.svg": "a66b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3ce";